/* eslint-disable no-use-before-define, no-unused-vars */
import React from "react";
import {
  ActivityIndicator,
  Button as RNButton,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import MenuButton from "../components/MenuButton";
import WebHeading from "../components/WebHeading";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { commission, initValidation } from "../redux/actions/validation";
import Icon from "react-native-vector-icons/FontAwesome";
import { goHome, resetStore } from "../redux/actions/menu";
import { insertSerialNum } from "../redux/actions/box";
import { goHomeWeb } from "../utils/goTo";
import { RepositStyles } from "../utils/styles";
import storage from "../utils/storage";

const errorColors = {
  green: "#51C76D",
  orange: "#F0A436",
  red: "#E02154",
};

const check = (
  <Icon
    name="check-circle"
    size={100}
    style={{ marginBottom: 30 }}
    color={errorColors.positive}
  />
);

const checkCircle = (
  <Icon name="check-circle" size={20} color={errorColors.positive} />
);
const timeCircle = (
  <Icon name="exclamation-circle" size={20} color={errorColors.negative} />
);
const questionCircle = (
  <Icon name="warning" size={20} color={errorColors.unknown} />
);

const mapStateToProps = (state) => ({
  box: state.box,
  validation: state.validation,
});

const mapDispatchToProps = (dispatch) => {
  return {
    validationActions: bindActionCreators(
      { initValidation, goHome, commission, resetStore, insertSerialNum },
      dispatch
    ),
  };
};
const ValidationComponent = ({
  name,
  message,
  state,
  value,
  unit,
  longMessage,
}) => {
  return (
    <View
      style={{ flexDirection: "row", marginVertical: 10, marginHorizontal: 20 }}
    >
      <Text style={{ marginTop: 2 }}>
        {state === "good"
          ? checkCircle
          : state === "orange"
          ? questionCircle
          : timeCircle}
      </Text>
      <View>
        <Text
          style={{
            ...RepositStyles.welcomeText,
            marginLeft: 10,
            color:
              state === "good"
                ? errorColors.positive
                : state === "orange"
                ? errorColors.unknown
                : errorColors.negative,
          }}
        >
          {name}
        </Text>
        {value === null || value === undefined ? null : (
          <Text style={{ marginHorizontal: 10, marginVertical: 2 }}>
            2 minute average:{" "}
            <Text style={{ fontWeight: "bold" }}>
              {" "}
              {value.toPrecision(3) + unit}{" "}
            </Text>
          </Text>
        )}
        {state === "good" ? null : (
          <View>
            <Text
              style={
                Platform.OS === "web"
                  ? {
                      maxWidth: 750,
                      width: "85vw",
                      marginHorizontal: 10,
                      marginVertical: 2,
                    }
                  : { marginHorizontal: 10, marginVertical: 2 }
              }
            >
              <Text style={{ fontWeight: "bold" }}>{message}</Text> {"\n"}
              {longMessage}
            </Text>
          </View>
        )}
      </View>
    </View>
  );
};

const ErrorSummary = ({ components, phaseComponents }) => {
  const errorComponents = [...components, ...phaseComponents];
  return (
    <View style={{ flex: 1, alignItems: "stretch" }}>
      <View
        style={{
          flex: 1,
          justifyContent: "flex-end",
          borderBottomWidth: 1,
          borderBottomColor: "#D2D2D2",
          marginHorizontal: 20,
        }}
      >
        <Text
          style={{
            ...RepositStyles.welcomeText,
            textAlign: "center",
            fontSize: 16,
            marginBottom: 8,
          }}
        >
          {errorComponents.length} Problem
          {errorComponents.length === 1 ? null : "s"} found during setup
        </Text>
      </View>
      <View style={{ flex: 10 }}>
        <ScrollView showsVerticalScrollIndicator={false} style={{ flex: 1 }}>
          {errorComponents.map((component) => (
            <ValidationComponent
              key={component.name}
              name={component.name}
              message={component.short}
              state={component.state}
              value={component.value}
              unit={component.unit}
              longMessage={component.message}
            />
          ))}
        </ScrollView>
      </View>
    </View>
  );
};

const FullReport = ({ components, phases }) => {
  return (
    <View style={{ flex: 1, alignItems: "stretch" }}>
      <ScrollView style={{ flex: 1 }} showsVerticalScrollIndicator={false}>
        {components.map((component) => (
          <ValidationComponent
            key={component.name}
            name={component.name}
            message={component.short}
            state={component.state}
            value={component.value}
            unit={component.unit}
          />
        ))}
        {phases.map((phase) => {
          return (
            <View key={phase.title}>
              <Text
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  backgroundColor: "#CBCBD3",
                  marginTop: 10,
                }}
              >
                {phase.title.charAt(0).toUpperCase() + phase.title.slice(1)}{" "}
                Phase
              </Text>
              {phase.data.map((component) => (
                <ValidationComponent
                  key={component.name}
                  name={component.name}
                  message={component.short}
                  state={component.state}
                  value={component.value}
                  unit={component.unit}
                />
              ))}
            </View>
          );
        })}
      </ScrollView>
    </View>
  );
};

class Validation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullReport: false,
    };
  }
  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "Validation",
  };

  finishAndGoHome = () => {
    this.props.validationActions.commission(this.props.box.serialNumber);
    if (Platform.OS === "web") {
      this.props.validationActions.resetStore();
      goHomeWeb();
    } else {
      this.props.validationActions.goHome();
    }
  };

  reValidate = () => {
    this.props.validationActions.initValidation(this.props.box.serialNumber);
  };

  componentDidMount() {
    let serialNum = this.props.box.serialNumber;
    if (!serialNum) {
      storage
        .load({ key: "serialNum" })
        .then((ret) => {
          this.props.validationActions.insertSerialNum(ret);
          this.props.validationActions.initValidation(ret);
        })
        .catch((err) => {
          console.log(err);
          this.props.validationActions.initValidation(
            this.props.box.serialNumber
          );
        });
    } else {
      this.props.validationActions.initValidation(this.props.box.serialNumber);
    }
  }
  render() {
    let phaseComponents = [];
    for (let [key, value] of Object.entries(
      this.props.validation.phaseComponents
    )) {
      let errors =
        Object.values(value).filter((component) => component.state !== "good")
          .length > 0
          ? true
          : false;
      phaseComponents.push({
        title: key,
        data: Object.values(value),
        error: errors,
      });
    }

    let problemPhaseComponents = [];
    for (let [key, value] of Object.entries(
      this.props.validation.phaseComponents
    )) {
      let errors = Object.values(value)
        .filter((component) => component.state !== "good")
        .map((component) => {
          return {
            ...component,
            name:
              key.charAt(0).toUpperCase() +
              key.slice(1) +
              " Phase " +
              component.name,
          };
        });
      problemPhaseComponents.push(...errors);
    }
    let navigate;
    if (Platform.OS !== "web") {
      navigate = this.props.navigation.navigate;
    } else {
      navigate = null;
    }
    return (
      <View style={styles.wrapper}>
        <WebHeading title="Validation" />
        <View
          style={{
            flex: 1,
            alignItems: "stretch",
            justifyContent: "center",
            flexDirection: "row",
          }}
        >
          <View style={{ flex: 1, maxWidth: 800 }}>
            <View style={{ flex: 1, justifyContent: "center", minHeight: 50 }}>
              <Text style={[RepositStyles.headerText]}>Report</Text>
            </View>
            <View style={{ flex: 10 }}>
              {this.props.validation.fetching ? (
                <View style={{ flex: 1 }}>
                  <View style={{ flex: 1 }} />
                  <View
                    style={{
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ActivityIndicator size="large" />
                    <Text
                      style={{
                        ...RepositStyles.headerText,
                        marginVertical: 30,
                      }}
                    >
                      Validating Installation
                    </Text>
                  </View>
                  <View style={{ flex: 3 }} />
                </View>
              ) : this.state.fullReport ? (
                <View style={{ flex: 1, alignItems: "stretch" }}>
                  <View style={{ flex: 10 }}>
                    <FullReport
                      components={this.props.validation.allComponents}
                      phases={phaseComponents}
                    />
                  </View>
                  <View style={{ flex: 1, justifyContent: "center" }}>
                    <View
                      style={{
                        flex: 1,
                        justifyContent: "center",
                        marginBottom: 10,
                        minHeight: 30,
                      }}
                    >
                      <RNButton
                        title="Show summary"
                        onPress={() => this.setState({ fullReport: false })}
                        color="#4698CB"
                      />
                    </View>
                    <View
                      style={{
                        flex: 1,
                        justifyContent: "center",
                        marginBottom: 10,
                        minHeight: 30,
                      }}
                    >
                      <RNButton
                        title="Revalidate"
                        onPress={() => this.reValidate()}
                        color="#4698CB"
                      />
                    </View>
                  </View>
                </View>
              ) : (
                <View style={{ flex: 1, alignItems: "stretch" }}>
                  {this.props.validation.status === "good" ? (
                    <View
                      style={{
                        flex: 3,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            ...RepositStyles.welcomeText,
                            textAlign: "center",
                            fontSize: 16,
                            marginHorizontal: 50,
                          }}
                        >
                          The Reposit Box now is now talking to Reposit and
                          appears to be functioning correctly.
                        </Text>
                      </View>
                      <View style={{ flex: 2, alignItems: "center" }}>
                        {check}
                      </View>
                      <Text style={RepositStyles.paragraphText}>
                        Some issues can take up to 24 hours to present
                        themselves so the Reposit Support Team will monitor this
                        system and contact you if there are any issues.
                      </Text>
                      <Text style={RepositStyles.paragraphText}>
                        {"\n"}The owner will receive a confirmation email with
                        their Reposit password in 1-2 business days and we'll
                        also send you a confirmation email.
                      </Text>
                    </View>
                  ) : (
                    <View style={{ flex: 10, justifyContent: "center" }}>
                      <ErrorSummary
                        components={this.props.validation.allComponents.filter(
                          (component) => component.state !== "good"
                        )}
                        phaseComponents={problemPhaseComponents}
                      />
                    </View>
                  )}
                  <View style={{ flex: 1, justifyContent: "center" }}>
                    <View
                      style={{
                        flex: 1,
                        justifyContent: "center",
                        marginBottom: 10,
                        minHeight: 30,
                      }}
                    >
                      <RNButton
                        title="Show full report"
                        onPress={() => this.setState({ fullReport: true })}
                        color="#4698CB"
                      />
                    </View>
                    {this.props.validation.status === "good" ? (
                      <View
                        style={{
                          flex: 1,
                          marginBottom: 10,
                          justifyContent: "center",
                          minHeight: 30,
                        }}
                      >
                        <RNButton
                          title="Done"
                          onPress={() => this.finishAndGoHome()}
                          color="#4698CB"
                        />
                      </View>
                    ) : (
                      <View
                        style={{
                          flex: 1,
                          marginBottom: 10,
                          justifyContent: "center",
                          minHeight: 30,
                        }}
                      >
                        <RNButton
                          title="Revalidate"
                          onPress={() => this.reValidate()}
                          color="#4698CB"
                        />
                      </View>
                    )}
                  </View>
                </View>
              )}
            </View>
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: { flex: 1, backgroundColor: "white" },
  heading: {
    marginHorizontal: 20,
  },
  headingText: { fontSize: 24, textAlign: "center", fontWeight: "300" },
  text: {
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 10,
  },
  bodyText: {
    marginVertical: 10,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Validation);



// WEBPACK FOOTER //
// ./src/containers/Validation.js